import { render, staticRenderFns } from "./logoutModal.vue?vue&type=template&id=1654544a&scoped=true"
import script from "./logoutModal.vue?vue&type=script&lang=js"
export * from "./logoutModal.vue?vue&type=script&lang=js"
import style0 from "./logoutModal.vue?vue&type=style&index=0&id=1654544a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654544a",
  null
  
)

export default component.exports